import { isSyncedBlockAttributes } from '../ui/extensions/synced-block/utils/synced-block';
export var findSyncedBlockParent = function findSyncedBlockParent($pos) {
  for (var i = 0; i <= $pos.depth; i++) {
    var node = $pos.node(i);
    if (isSyncedBlockAttributes(node.attrs)) {
      return {
        node: node,
        attributes: node.attrs
      };
    }
  }
  return;
};